var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTurn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "1.5 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_1271)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94165 -0.016514L12.5938 5.63703L10.5622 7.66858L8.37838 5.48474V14.381C8.37838 15.6396 8.87836 16.8466 9.76832 17.7366C10.6583 18.6266 11.8653 19.1265 13.1239 19.1265C14.3825 19.1265 15.5896 18.6266 16.4795 17.7366C17.3695 16.8466 17.8695 15.6396 17.8695 14.381L17.8695 2.01503H20.7429L20.7429 14.381C20.7429 15.3815 20.5458 16.3723 20.163 17.2967C19.7801 18.221 19.2189 19.061 18.5114 19.7684C17.8039 20.4759 16.964 21.0371 16.0396 21.42C15.1152 21.8029 14.1245 22 13.1239 22C12.1234 22 11.1326 21.8029 10.2082 21.42C9.28387 21.0371 8.44395 20.4759 7.73646 19.7684C7.02897 19.061 6.46776 18.221 6.08487 17.2967C5.70198 16.3723 5.50491 15.3815 5.50491 14.381V5.48474L3.31964 7.66858L1.28809 5.63703L6.94165 -0.016514Z",
    fill: "#025430"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_1271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 25,
    fill: "white",
    transform: "translate(22.0001 24) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurn);
export default __webpack_public_path__ + "static/media/turn.e466e3ad.svg";
export { ForwardRef as ReactComponent };